const Backbone = require('backbone');
const dustjs = require('dustjs');
const _squareFootCalculatorDimensionsDust = require('store/global/pages/products/_square_foot_calculator_dimensions.dust');
var validator = window.BCOM.util.validator,
	dimensionDefaults = {
		xFeet: 0,
		xInches: 0,
		yFeet: 0,
		yInches: 0
	};

var _handleAddingRow = function() {
	var dimensions = this.model.get('squareFootDimensions'),
		$dimensionGroup = this.$('#square-foot-dimensions');

	dustjs.render(
		_squareFootCalculatorDimensionsDust,
		{
			sectionNumber: dimensions.length + 1
		},
		function(error, markup) {
			if (!error) {
				$dimensionGroup.append(markup);
			}
		}
	);
	dimensions.push(dimensionDefaults);
	this.model.set('squareFootDimensions', dimensions);
};

var _setRowSquareFeetByIndex = function(index, data) {
	var currentDimensions = this.model.get('squareFootDimensions');
	currentDimensions[index] = {
		xFeet: parseInt(data.x_feet, 10) || 0,
		xInches: parseInt(data.x_inches, 10) || 0,
		yFeet: parseInt(data.y_feet, 10) || 0,
		yInches: parseInt(data.y_inches, 10) || 0
	};
	this.model.set('squareFootDimensions', currentDimensions);
};

var _getSquareFeet = function() {
	var squareInches = 0,
		squareFeet,
		wastePercent = this.model.get('squareFootWastePercent') / 100,
		waste,
		total;
	this.model.get('squareFootDimensions').forEach((dimensions) => {
		squareInches = squareInches + (dimensions.xFeet * 12 + dimensions.xInches) * (dimensions.yFeet * 12 + dimensions.yInches);
	});
	squareFeet = Math.floor(squareInches / 12 / 12);
	waste = squareFeet * wastePercent;
	total = squareFeet + waste;
	return {
		subtotal: squareFeet,
		waste: parseFloat(waste.toFixed(2)),
		total: parseFloat(total.toFixed(2))
	};
};

var _enforceNumeric = function($input) {
	var value = $input.val();
	if (!validator.isNumeric(value) && value !== '') {
		$input.val(validator.whitelist(value, '0123456789'));
	}
};
var _renderItemizedCalculations = function() {
	var dimensions = _getSquareFeet.call(this);
	this.$('#square-foot-subtotal').text(dimensions.subtotal);
	this.$('#square-foot-waste').text(dimensions.waste);
	this.$('#square-foot-total').text(dimensions.total);
};

var _recalculate = function($form) {
	var index = $form.attr('id').split('-')[3] - 1,
		data = this.serializeForm($form);
	_setRowSquareFeetByIndex.call(this, index, data);
	_renderItemizedCalculations.call(this);
	Backbone.trigger('squareFeet:updated', _getSquareFeet.call(this));
};

var _handleDimensionChange = function(event) {
	var $input = this.$(event.currentTarget),
		$form = $input.closest('form');
	_enforceNumeric($input);
	_recalculate.call(this, $form);
};

var _handlePercentageChange = function() {
	var $input = this.$('#waste-percentage');
	_enforceNumeric($input);
	this.model.set('squareFootWastePercent', parseInt($input.val() || 0, 10));
	_renderItemizedCalculations.call(this);
	Backbone.trigger('squareFeet:updated', _getSquareFeet.call(this));
};

module.exports = Backbone.View.extend({
	initialize: function() {
		this.model.set('squareFootDimensions', this.model.get('squareFootDimensions') || [dimensionDefaults]);
		this.model.set('squareFootWastePercent', parseInt(this.$('#waste-percentage').val() || 0, 10));
	},
	events: {
		'click .js-add-row': _handleAddingRow,
		'keyup input[type=tel]:not(#waste-percentage)': _handleDimensionChange,
		'keyup #waste-percentage': _handlePercentageChange,
		'click #show-calculator': 'toggleCalculator'
	},
	reset: function() {
		this.model.set('squareFootDimensions', []);
		this.$('#square-foot-dimensions').empty();
		_handleAddingRow.call(this);
		_renderItemizedCalculations.call(this);
	},
	toggleCalculator: function(event) {
		event.preventDefault();
		this.$('#calculator-section').toggleClass('hidden');
		this.$('.js-expand-icon').toggleClass('ico-hide');
		this.$('.js-collapse-icon').toggleClass('ico-hide');
	}
});
